import { useQuery } from "@tanstack/react-query";
import type { Operator } from "../models/Operator";
import { getOperators } from "../repositories/OperatorsRepository";

export const OPERATORS_QUERY_KEYS = {
	all: ["operators"] as const,
	list: () => ["operators", "list"] as const,
	byId: (id: number | null) => ["operators", "detail", id] as const,
};

export const useOperators = () => {
	const query = useQuery<Operator[], Error>({
		queryKey: OPERATORS_QUERY_KEYS.list(),
		queryFn: () => getOperators(),
	});

	return {
		operators: query.data ?? [],
		isLoading: query.isLoading,
		error: query.error,
		refetch: query.refetch,
	};
};
